import React, { useState } from "react";
import { ChatConversation } from "../../models/Chat";
import { useChat } from "./ChatProvider";
import { BrowseChannelsDialog, NewChannelDialog, NewChatDialog } from "./NewChatDialog";
import { useChatDirectory } from "./chatUtils";

type OpenDialog = "chat" | "channel" | "browse" | null;

/** New chat / new channel / browse channels dialogs shared by the full page and the sidebar. */
export function useChatDialogs(onOpenConversation: (conversation: ChatConversation) => void) {
  const { me, staff, usersById } = useChatDirectory();
  const { conversations, upsertConversation } = useChat();
  const [openDialog, setOpenDialog] = useState<OpenDialog>(null);

  const close = () => setOpenDialog(null);
  const openCreated = (conversation: ChatConversation) => {
    upsertConversation(conversation);
    onOpenConversation(conversation);
  };

  const dialogs = (
    <>
      <NewChatDialog
        open={openDialog === "chat"}
        onClose={close}
        staff={staff}
        meId={me.id}
        onCreated={openCreated}
      />
      <NewChannelDialog open={openDialog === "channel"} onClose={close} onCreated={openCreated} />
      <BrowseChannelsDialog
        open={openDialog === "browse"}
        onClose={close}
        channels={conversations.filter((c) => c.type === "channel")}
        meId={me.id}
        usersById={usersById}
        onOpen={(conversation) => {
          close();
          onOpenConversation(conversation);
        }}
        onJoined={(conversation) => {
          close();
          openCreated(conversation);
        }}
      />
    </>
  );

  return {
    openNewChat: () => setOpenDialog("chat"),
    openNewChannel: () => setOpenDialog("channel"),
    openBrowseChannels: () => setOpenDialog("browse"),
    dialogs,
  };
}
